import { Box, Paper } from "@mui/material";
import type { FC } from "react";
import type { UUID } from "../../../../../../../utils/uuid";
import { FOOTER_HEIGHT } from "../../../../../../generic/components/fixed-footer";
import { PreviewAlert } from "./preview-alert";
import { PreviewBodyContent } from "./preview-body-content";
import { PreviewBodyHead } from "./preview-body-head";

export const PreviewBody: FC<{
  momentId: UUID;
  isNewsletter?: boolean;
  sendTestButton?: React.ReactNode;
}> = ({ momentId, isNewsletter, sendTestButton }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        flexGrow: 1,
        overflow: "auto", // Allows scrolling in the main content area
        height: `calc(100% - ${FOOTER_HEIGHT})`, // Subtract the height of the footer
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PreviewAlert sendTestButton={sendTestButton} />
      <PreviewBodyHead isNewsletter={isNewsletter ?? false} />
      <Box
        sx={{
          bgcolor: "background.paper",
          flexGrow: 1, // This will make the Box take up all remaining space
        }}
      >
        <PreviewBodyContent momentId={momentId} isNewsletter={isNewsletter ?? false} />
      </Box>
    </Paper>
  );
};
